import request from "@/utils/request";

// 模糊查询公司信息
export function getCompanyName(data) {
  return request({
    url: "/report/getCompanyInfo/companyName",
    method: "post",
    data,
  });
}

// 根据id查详情
export function getReport(data) {
  return request({
    url: "/report/id",
    method: "post",
    data,
  });
}